{
  "patliteEditDialog": {
    "title": "PATLITE settings",
    "text": "Area:",
    "label": "Users to notify (multiple selection)",
    "placeholder": "Select users"
  },
  "patliteFilterBar": {
    "placeholder": "Search by area name or camera name",
    "label": "Sort by"
  },
  "patliteState": {
    "createdAtDesc": "Latest detection first",
    "areaAsc": "Area name (A–Z)"
  },
  "patliteTable": {
    "label": "Area",
    "label2": "Last detected at",
    "label3": "Before detection",
    "label4": "After detection",
    "text": "An error occurred.",
    "text2": "No detections are available to view."
  },
  "usePatliteViewState": {
    "enqueueSnackbar": "Settings updated.",
    "enqueueSnackbar2": "The settings couldn't be updated."
  },
  "patlite": {
    "title": "PATLITE management"
  }
}
